import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Blogcard from '../../components/blogcard';
import CustomCarousel from '../../components/carousel';
import blogImage from '../../images/blogg.svg';

function mediaUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    let relative = String(path).replace(/^\//, '');
    if (!relative.startsWith('uploads/blogs/')) {
        relative = `uploads/blogs/${relative.split('/').pop()}`;
    }
    const root = (process.env.REACT_APP_UPLOAD_URL || '').replace(/\/$/, '');
    return `${root}/${relative}`;
}

function BlogBody() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    document.title = `Welcome to Yebokenny Blog`;
    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/blogs`);
                const rows = response.data?.data || [];
                const formattedBlogs = rows.map(blog => ({
                    id: blog.id,
                    image: mediaUrl(blog.imagePath) || blogImage,
                    category: blog.category || 'General',
                    title: blog.title,
                    author: blog.author || 'Yebokenny',
                    date: blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : '',
                    likes: blog.likes || 0,
                    comments: blog.comments || 0,
                    views: blog.views || 0,
                }));
                setBlogs(formattedBlogs);
            } catch (err) {
                console.error('Error fetching blogs:', err);
                setError('Failed to fetch blogs. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <div>
            <div className="flex-col items-center bg-[url('images/faqsheader.svg')] bg-cover bg-center bg-no-repeat py-6 pb-10">
                <div className='text-white text-[30px] lg:text-[48px] font-[500] lg:w-[60%] mx-auto mt-5'>Blog</div>
                <div className='font-[400] text-[24px] text-white pt-2 pb-10 lg:w-[62%] mx-auto'>Stay informed with expert tips, industry trends, and actionable ideas to help you grow and succeed in business.</div>
            </div>
            <div className='px-10 lg:px-20 py-10 lg:py-20'>
                {loading ? (
                    <p className="text-center text-gray-500">Loading blogs...</p>
                ) : error ? (
                    <p className="text-center text-red-500">{error}</p>
                ) : (
                    <CustomCarousel
                        defaultItemsPerSlide={3}
                        defaultRows={3}
                        responsive={[
                            { breakpoint: 1024, itemsPerSlide: 1, rows: 8 },
                            { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                            { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                        ]}
                    >
                        {blogs.map((item) => (
                            <Blogcard key={item.id} {...item} />
                        ))}
                    </CustomCarousel>
                )}
            </div>
            {/* <div className='mx-10 lg:mx-20 mb-20'>
                <div className='rounded-[8px] bg-[#F7F7F7] mb-10'>
                    <div className='w-[90%] lg:w-[60%] mx-auto flex flex-col text-center pt-5 pb-10'>
                        <div className='text-[24px] lg:text-[48px] font-[600] mx-auto'>Subscribe to blog </div>
                        <div className='text-[#4F4F4F] text-[20px] font-[400] text-center mt-2'>Subscribe to our blog and be the first to read our latest blog.</div>
                        <form className='flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-3 mx-auto mt-5'>
                            <input className='rounded-[8px] bg-white text-[#828282] outline-none h-[50px] lg:w-[400px] pl-5' placeholder='Enter your email address' />
                            <button className='bg-[#008B39] text-white rounded-[8px] h-[50px] lg:w-[150px]'>Subscribe</button>
                        </form>
                    </div>
                </div>
            </div> */}
        </div>
    );
}

export default BlogBody;